export default "__VITE_ASSET__D_ftStHa__"